import { render, staticRenderFns } from "./anfky.vue?vue&type=template&id=1bb2d6b9&scoped=true&"
import script from "./anfky.vue?vue&type=script&lang=js&"
export * from "./anfky.vue?vue&type=script&lang=js&"
import style0 from "./anfky.vue?vue&type=style&index=0&id=1bb2d6b9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb2d6b9",
  null
  
)

export default component.exports